import { FormProvider, useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import Authentication from "./Authentication";
import Orders from "./Orders";

const Verification = () => {
  const location = useLocation();

  const orderId = new URLSearchParams(location.search).get("order_id");
  const clientId = new URLSearchParams(location.search).get("client_id");
  const portfolioId = new URLSearchParams(location.search).get("portfolio_id");
  const logo = location.search.split("logo=")[1];

  const form = useForm({
    defaultValues: {
      auth: {
        phoneNumber: "",
        email: "",
        countryCode: "+91",
      },
      isVerified: false,
      token: "",
      consentAccepted: false,
      paymentType: "",
    },
  });

  const watchVerified = form.watch("isVerified");

  return (
    <FormProvider {...form}>
      {watchVerified ? (
        <Orders
          orderId={orderId}
          clientId={clientId}
          logo={logo}
          portfolioId={portfolioId}
        />
      ) : (
        <Authentication logo={logo} clientId={clientId} />
      )}
    </FormProvider>
  );
};

export default Verification;
